export function materialReplaceAppliedToast(summary: {
  updated: number;
  recipes: number;
  source_deactivated: boolean;
}): string {
  const { updated, recipes, source_deactivated } = summary;
  return `Replaced on ${updated} line${updated === 1 ? "" : "s"} · ${recipes} recipe${
    recipes === 1 ? "" : "s"
  }${source_deactivated ? " · source deactivated" : ""}`;
}

export function materialUseCreatedToast(summary: { name: string; members: number }): string {
  const { name, members } = summary;
  return `Created use “${name}” with ${members} interchangeable material${
    members === 1 ? "" : "s"
  }. On Models, add a Use line to reference it.`;
}
